import { ZodNumber, ZodTuple, z } from 'zod';

import { ZodBOExternalPermissionT } from '@Common/types/bo_external/resources';
import { ZodSecureEmail } from '@Common/types/zod/zod-email';
import { ZodPhoneNumber } from '@Common/types/zod/zod-phone-number';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const BOExternalAdminRolesValues = [
  'default',
  'admin_level_1',
  'admin_level_2',
  'admin_level_3',
  'admin_level_4',
  'distributor',
  'inspector',
] as const;
export const ZodBOExternalAdminRoles = z.enum(BOExternalAdminRolesValues);
export type BOExternalAdminRoles = z.TypeOf<typeof ZodBOExternalAdminRoles>;

export const boExternalAuthRoleValues = ['b2b_admin', 'b2b_distributor', 'b2b_inspector'] as const;
export const ZodBOExternalAuthRole = z.enum(boExternalAuthRoleValues);

export type BoExternalAuthRole = z.infer<typeof ZodBOExternalAuthRole>;
const ZodBOExternalPermissionTArray = z.array(ZodBOExternalPermissionT).optional();

export const ZodBoExternalRoleDefinitions = z.object(
  Object.fromEntries(
    BOExternalAdminRolesValues.map((key) => [key, ZodBOExternalPermissionTArray]),
  ) as Record<(typeof BOExternalAdminRolesValues)[number], typeof ZodBOExternalPermissionTArray>,
);

export type BoExternalPermissionsByRole = Required<z.TypeOf<typeof ZodBoExternalRoleDefinitions>>;

export const ZodBOExternalAdminUser = z
  .object({
    id: z.number().int(),
    auth_id: z.number().int(),
    auth_role: ZodBOExternalAuthRole,
    email: ZodSecureEmail,
    first_name: ZodTrimmedString.nullable(),
    last_name: ZodTrimmedString.nullable(),
    locale: ZodTrimmedString,
    phone_number: ZodPhoneNumber.nullable(),
    company_id: z.array(z.number().int()).nonempty() as unknown as ZodTuple<[ZodNumber], ZodNumber>,
    roles: z.array(ZodBOExternalAdminRoles),
    bo_user_id: z.number().int().nullable(),
  })
  .transform((props) => ({ ...props, session_type: 'bo_external' as const }))
  .meta({ override: { type: 'object' } });

export type BOExternalAdminUser = z.TypeOf<typeof ZodBOExternalAdminUser>;
